import React, { useEffect, useState } from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { RecoveryEstimator } from './components/RecoveryEstimator';
import { HowItWorks } from './components/HowItWorks';
import { Stats } from './components/Stats';
import { Features } from './components/Features';
import { ManymoonsMarketplace } from './components/ManymoonsMarketplace';
import { Testimonial } from './components/Testimonial';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { RecoveryPortal } from './components/RecoveryPortal';
import { SignIn } from './components/SignIn';
function Home() {
  const [estimatorOpen, setEstimatorOpen] = useState(false);
  const openEstimator = () => setEstimatorOpen(true);
  return <div className="min-h-full w-full bg-cream text-ink" data-id="element-0" data-mp="23vcjqs9ypabm">
      <Navbar onEstimate={openEstimator} data-id="element-1" data-mp="23utbk3a460as" />
      <main data-id="element-2" data-mp="3ijxokogyjwiu">
        <Hero onEstimate={openEstimator} data-id="element-3" data-mp="3ikh8ubu2yx01" />
        <HowItWorks data-id="element-4" data-mp="3ijfvg0pldyf5" />
        <Stats data-id="element-5" data-mp="3ihuyk4ft23e4" />
        <Features data-id="element-6" data-mp="3mlj98vzqhf3l" />
        <ManymoonsMarketplace data-id="element-7" data-mp="3ml1234bj9ggw" />
        <Testimonial data-id="element-8" data-mp="3mjzsz5e2v41t" />
        <FinalCTA onEstimate={openEstimator} data-id="element-9" data-mp="3mjg8bgx1m1k3" />
      </main>
      <Footer data-id="element-10" data-mp="3rdas0kcnegj6" />
      <RecoveryEstimator open={estimatorOpen} onClose={() => setEstimatorOpen(false)} data-id="element-11" data-mp="3rcsy3udgkeef" />
    </div>;
}
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto'
    });
  }, [pathname]);
  return null;
}
export function App() {
  return <BrowserRouter data-id="element-12" data-mp="33myix65o2dr0">
      <ScrollToTop data-id="element-13" data-mp="38lromcepp0gm" />
      <Routes data-id="element-14" data-mp="38l8iru2c62iy">
        <Route path="/" element={<Home data-id="element-16" data-mp="38k6v8q44vnkc" />} data-id="element-15" data-mp="38li619vzxvky" />
        <Route path="/signin" element={<SignIn data-id="element-18" data-mp="3dkl60fx4dbm2" />} data-id="element-17" data-mp="38nuqput52k1p" />
        <Route path="/recovery-portal" element={<RecoveryPortal data-id="element-20" data-mp="3dm5vvs8ho6dl" />} data-id="element-19" data-mp="3dl4k1ljnffut" />
      </Routes>
    </BrowserRouter>;
}